/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_content_delivery_bucket": "quizbiz-20200620203655-hostingbucket-dev",
    "aws_content_delivery_bucket_region": "us-east-1",
    "aws_content_delivery_url": "http://quizbiz-20200620203655-hostingbucket-dev.s3-website-us-east-1.amazonaws.com",
    "aws_appsync_graphqlEndpoint": "https://dgek22a2mfh6rm4b4s5es3mqhu.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-dzpddxprzfbexcaqw5oqpf4efe",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_xb2iMhp8r",
    "aws_user_pools_web_client_id": "4cslqa7nq80g2k0adfl0fuqdl9",
    "oauth": {}
};


export default awsmobile;
